class HubspotForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)

    this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
  }

  handleSubmit (event) {
    event.preventDefault()

    this.els.form.element.setAttribute('aria-hidden', true)
    this.els.submitted.element.setAttribute('aria-hidden', false)

    const customerEmail = this.els.email?.element?.value

    if (!customerEmail) return

    window.BAO.dispatchEvent(window.BAO.EVENTS.HUBSPOT.FORM_SUBMITTED, {
      customerEmail,
    })
  }
}

if (!customElements.get('hubspot-form')) {
  customElements.define('hubspot-form', HubspotForm)
}
